<h2>
  {{ headerText }}
</h2>

<div class="flex gap-20">
  @if (addText) {
    <app-button class="flex items-center" buttonType="outline" (click)="onAddClick()">
      {{ addText }}
      <i class="fa-solid fa-circle-plus size-24 text-cb-gold"></i>
    </app-button>
  }

  <div class="search">
    <input class="shared-input search-input" placeholder="Search ..." (input)="onInput($event)" />
    <i class="fa-solid fa-magnifying-glass text-dark-gray search-icon"></i>
  </div>
</div>
